import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import axios from "../../axios-instance.js";

import './Preregisters.sass';
import { SeasonPassFieldLabel } from '../SeasonPass/SeasonPassFieldLabel';
import { isValidEmail } from '../../helpers/validators.js';
import { toast } from 'react-toastify';
import CheckBox from '../../components/UI/Checkbox/CheckBox';
import { getCurrentLanguageTexts, setLangCode } from '../../constants/seasonPassPersonalInfoLangs.js';
import { getRegion } from '../../helpers/getRegion.js';
import NewLoader from '../../components/NewLoader/NewLoader.js';

const initUserData = {
  firstName: '',
  lastName: '',
  email: '',
  isMarketingAccepted: false,
};

const Preregisters = (props) => {
  const [eventData, setEventData] = useState({});
  const [userData, setUserData] = useState(initUserData);
  const [validEmail, setValidEmail] = useState(true);
  const [isLoading, setLoading] = useState(true);

  const { preregisterPage } = getCurrentLanguageTexts();
  const region = getRegion();

  const getEventData = async () => {
    const eventSlug = props.match.params.slug;

    setLoading(true);

    try {
      const { data } = await axios.get(`/EventPublicInfo/BySlug/${eventSlug}`);

      setEventData(data);
    } catch (error) {
      toast.error(preregisterPage["Event data not received"]);
    } finally {
      setLoading(false);
    };
  };

  const handleChangeField = (field, value) => {
    setUserData(prev => ({
      ...prev,
      [field]: value,
    }));

    if (field === 'email') {
      setValidEmail(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = isValidEmail(userData.email) || userData.email === "";

    if (!isValid) {
      setValidEmail(isValid);

      return;
    };

    const body = {
      ...userData,
      buyerEmail: userData.email,
      eventId: eventData.eventId,
    };

    const headers = {
      "Content-Type": "application/json-patch+json",
      Accept: "text/plain",
    };

    setLoading(true);

    try {
      const { data } = await axios.post(`/PreSale`, body, headers);

      if (data.isSuccess) {
        toast.success(preregisterPage["Thanks for registration"]);
        setUserData(initUserData);
      } else {
        throw new Error(data.errorMessage)
      }
    } catch (error) {
      toast.error(String(error.message))
    } finally {
      setLoading(false);
    };
  };

  useEffect(() => {
    getEventData();

    if (window.location.origin.includes('sixtix.rs')) {
      setLangCode('rs');
    } else {
      setLangCode('en');
    }
  }, []);

  if (isLoading) {
    return (
      <div className='preregisters__loader'>
        <NewLoader />
      </div>
    )
  }

  return (
    <section className="preregisters">
      <div className="preregisters__container">
        <img
          className="preregisters__image"
          src={window.screen.width <= 480 && eventData.mobileImageUrl
              ? eventData.mobileImageUrl
              : eventData.imageUrl}
          alt={eventData.eventName}
        />

        <h1>
          {eventData.eventName}
        </h1>

        {eventData.description && (<>
          <div className="preregisters__description" dangerouslySetInnerHTML={{ __html: eventData.description }}>
          </div>
        </>)}

        <form className="preregisters__form">
          <div className="preregisters__fields">
            <div className="preregisters__field">
              <SeasonPassFieldLabel
                label={preregisterPage["First name"]}
                isRequired={true}
                className="partizan-open-selling__fields-label"
                shouldWrapInLabel={false}
              >
                <input
                  className="seasonpass__field-input"
                  name="firstName"
                  placeholder={preregisterPage["Enter your first name"]}
                  onChange={(e) => handleChangeField("firstName", e.target.value)}
                  type="text"
                  value={userData.firstName}
                />
              </SeasonPassFieldLabel>
            </div>
            <div className="preregisters__field">
              <SeasonPassFieldLabel
                label={preregisterPage["Last name"]}
                isRequired={true}
                className="partizan-open-selling__fields-label"
                shouldWrapInLabel={false}
              >
                <input
                  className="seasonpass__field-input"
                  name="lastName"
                  placeholder={preregisterPage["Enter your last name"]}
                  onChange={(e) => handleChangeField("lastName", e.target.value)}
                  type="text"
                  value={userData.lastName}
                />
              </SeasonPassFieldLabel>
            </div>
            <div className="preregisters__field">
              <SeasonPassFieldLabel
                label={preregisterPage["Email"]}
                isRequired={true}
                className="partizan-open-selling__fields-label"
                shouldWrapInLabel={false}
              >
                <input
                  className="seasonpass__field-input"
                  name="buyerEmail"
                  placeholder={preregisterPage["Enter your email"]}
                  onChange={(e) => handleChangeField("email", e.target.value.trim())}
                  type="email"
                  value={userData.email}
                />
                {!validEmail && (
                  <span className="partizan-open-selling__input-valid-error">
                    {preregisterPage["This is an invalid email"]}
                  </span>
                )}
              </SeasonPassFieldLabel>
            </div>
          </div>

          {/* <p style={{ margin: '0' }}>Napomena:</p>
          <ul>
            <li>
              Popunjavanjem forme dobijate pravo na rani uvid i kupovinu do 4 ulaznice (u zavisnosti od dostupnosti). 
            </li>
            <li>
              Pristup događaju na profilu biće aktivan za članove od 19.07.2025. , a za sve druge od 23.08.2025. godine 
            </li>
            <li>
              Za pristup događaju preko profila neophodno je da imate kompletirane podatke na svom profilu (ime, prezime, grad, broj telefona). 
            </li>
          </ul> */}

          <CheckBox
            checked={userData.isMarketingAccepted}
            id="marketing-agreement"
            name="marketing-agreement"
            onChange={() => handleChangeField("isMarketingAccepted", !userData.isMarketingAccepted)}
          >
            <span>
              {preregisterPage["Marketing agreement"]}
            </span>
          </CheckBox>

          <p>
            <strong>{preregisterPage["Privacy Policy and Terms"]}:</strong>
            <br />
              {preregisterPage["Your info is stored..."]}
            <a href={region.termsLink} target="_blank" rel="noopener noreferrer">
              {preregisterPage["Terms of Service"]}
            </a>
              {preregisterPage["and"]}
             <a href={region.policyLink} target="_blank" rel="noopener noreferrer">
              {preregisterPage["Privacy Policy"]}
             </a>. 
          </p>

          <button
            className="btn-primary preregisters__submit"
            type="submit"
            onClick={handleSubmit}
            disabled={!userData.firstName || !userData.lastName || !userData.email || !userData.isMarketingAccepted}
          >
            {preregisterPage["Submit"]}
          </button>
        </form>
      </div>
    </section>
  )
}

export default withRouter(Preregisters);